import { transparentize } from 'polished';
import React from 'react';

import type { DsrIconProps } from './wrappers';
import { Svg } from './wrappers';

const Icon = ({
  primaryColor,
  selectedColor,
  selected,
  ...svgProps
}: DsrIconProps): JSX.Element => (
  <Svg viewBox="0 0 24 24" {...svgProps}>
    <title>DSR/icon/object:default</title>
    <desc>Created with Sketch.</desc>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        // eslint-disable-next-line max-len
        d="M 19 20 L 5 20 C 4.398438 20 4 19.601562 4 19 L 4 5 C 4 4.398438 4.398438 4 5 4 L 19 4 C 19.601562 4 20 4.398438 20 5 L 20 19 C 20 19.601562 19.601562 20 19 20 Z M 19 20 "
        fill={selected ? selectedColor : transparentize(0.7, primaryColor)}
        fillRule="nonzero"
      />
      <path
        // eslint-disable-next-line max-len
        d="M 19 21 L 5 21 C 3.898438 21 3 20.101562 3 19 L 3 5 C 3 3.898438 3.898438 3 5 3 L 19 3 C 20.101562 3 21 3.898438 21 5 L 21 19 C 21 20.101562 20.101562 21 19 21 Z M 19 19 L 19 20 Z M 5 5 L 5 19 L 19 19 L 19 5 Z M 5 5 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        d="M 9 11 L 18 11 L 18 13 L 9 13 Z M 9 11 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        // eslint-disable-next-line max-len
        d="M 15.699219 16.699219 L 14.300781 15.300781 L 17.601562 12 L 14.300781 8.699219 L 15.699219 7.300781 L 20.398438 12 Z M 15.699219 16.699219 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
    </g>
  </Svg>
);

export default Icon;
